export const MERCHANT_TYPE = {
  RESTAURANT: 'restaurant',
  HOTEL: 'hotel',
  SOUVENIR: 'souvenir',
}

export const EXTERNAL_PARTNER = {
  Loop: 'loop',
  Smaregi: 'smaregi',
  SmaregiPOS: 'smaregi_pos',
  NEC: 'nec',
  Mmenu: 'mmenu',
  Sukiya: 'sukiya',
}

export const MERCHANT_TYPE_KEY = 'merchant_type'

export const COUNTRY = {
  ja: 'JP',
}
